<template>
	<div class="flows-list height-100">
		<template v-if="flows?.length > 0">
			<div v-for="flow in flows" class="height-100 mb-3" :key="flow.id">
				<slot name="card" v-bind="{ flowData: flow }">
					<FlowsViewModuleCard :flowData="flow" v-on="$listeners" />
				</slot>
			</div>
		</template>
		<template v-else-if="!isLoading">
			<h3 v-if="searchString?.length > 0" class="reg empty-container flex-centerize">
				Your search - {{ searchString }} - did not match any feature
			</h3>
			<slot v-else name="empty-state">
				<FlowsListEmptyState class="width-100 height-100 flex-centerize flex-column empty-container" />
			</slot>
		</template>
	</div>
</template>
<script>
import FlowsListEmptyState from './FlowsListEmptyState';
import FlowsViewModuleCard from '@/components/Modules/FlowsViewModuleCard.vue';
export default {
	name: 'FlowsList',
	components: { FlowsViewModuleCard, FlowsListEmptyState },
	props: {
		flows: { type: Array },
		searchString: { type: String },
		isLoading: { type: Boolean, default: false },
	},
};
</script>
<style scoped lang="scss">
.flows-list {
	display: flex;
	flex-direction: column;

	@media (max-width: 1100px) {
		padding: 10px 20px 10px 25px;
	}
}
.empty-container {
	margin-top: 100px;
}
</style>
